import { render, staticRenderFns } from "./DonationConfirm.vue?vue&type=template&id=606036ae&scoped=true&"
import script from "./DonationConfirm.vue?vue&type=script&lang=js&"
export * from "./DonationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DonationConfirm.vue?vue&type=style&index=0&id=606036ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606036ae",
  null
  
)

export default component.exports